/**
 * Eyebrow — the small uppercase label above section titles and card heads.
 * Adir's design language; reused across every tab so giving it an atom keeps
 * tracking consistent if we tweak the type spec later.
 */

import React from 'react';

export interface EyebrowProps {
  children: React.ReactNode;
  /** Override the default neutral grey — used to colour-tone section eyebrows. */
  color?: string;
  style?: React.CSSProperties;
}

export const Eyebrow: React.FunctionComponent<EyebrowProps> = ({
  children,
  color = '#94A3B8',
  style,
}) => (
  <div
    style={{
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color,
      ...style,
    }}
  >
    {children}
  </div>
);
